module.exports = __webpack_public_path__ + "img/swiper1.8237b813.jpg";